import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-descending_order",
  "use": "icon-descending_order-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-descending_order\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M17.72,4.83V15h2.45L16.9,19.17,13.63,15h2.45V4.83ZM11.18,16.64v1.68H3.83V16.64Zm1.64-5.9v1.68h-9V10.74Zm0-5.91V6.52h-9V4.83Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol